import React from "react";
import "./BlogCard.css";

const BlogCard = ({ blog }) => {
  return (
    <article className="blog-card">
      <div className="blog-image-wrapper">
        <img
          className="blog-image"
          src={blog.image}
          alt={blog.title}
          loading="lazy"
        />
      </div>

      <div className="blog-content">
        <p className="blog-date">{blog.date}</p>
        <h3 className="blog-title">{blog.title}</h3>
        <p className="blog-description">{blog.description}</p>

        <a href={blog.link} className="blog-link">
          Read More →
        </a>
      </div>
    </article>
  );
};

export default BlogCard;
